/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { v4SubnetsGetApiV4SubnetsSubnetId } from "../../funcs/v4SubnetsGetApiV4SubnetsSubnetId.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV4SubnetsSubnetIdRequest$inboundSchema,
};

export const tool$v4SubnetsGetApiV4SubnetsSubnetId: ToolDefinition<
  typeof args
> = {
  name: "v4-subnets-get-api-v4-subnets-subnet-id",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await v4SubnetsGetApiV4SubnetsSubnetId(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
